import { Link } from 'react-router-dom';
import { characters } from '@/mocks/characters';

export default function CharacterPreview() {
  const shown = characters.slice(0, 4);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
              角色设定
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">主要角色一图认识</h2>
          </div>
          <Link
            to="/characters"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            查看全部角色
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {shown.map((c) => (
            <Link
              key={c.id}
              to="/characters"
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="h-56 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name}（${c.role}）角色设定插画`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">{c.name}</h3>
                  <span
                    className={`rounded-full px-2.5 py-1 text-xs ${
                      c.accent === 'primary'
                        ? 'bg-primary-100 text-primary-800'
                        : c.accent === 'accent'
                          ? 'bg-accent-100 text-accent-800'
                          : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    {c.role}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-700">{c.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}